import React, { useEffect, useState } from "react";
import intl from "react-intl-universal";
import { mdiRefresh } from "@mdi/js";

import runnerRest from "../../rest/runnerRest";

import { Table } from "../components/Table";
import { Button } from "../components/Button";
import { Layout } from "../containers/Layout";
import { RunnerItem } from "./runners/RunnerItem";
import { ContentBody } from "../containers/ContentBody";
import { ContentHeader } from "../containers/ContentHeader";

export const Runners = () => {

    const [runners, setRunners] = useState([]);

    useEffect(() => {
        const fetchRunners = async () => {
            const runners = await runnerRest.getAll();
            setRunners(runners);
        };
        fetchRunners();
        const intervalId = setInterval(fetchRunners, 500);
        return () => clearInterval(intervalId);
    }, []);

    const restartAll = async () => {
        await runnerRest.shutdownAll();
    };

    return (
        <Layout>
            <ContentHeader title={intl.get("navigation.runners")}>
                <Button
                    svgIcon={mdiRefresh}
                    onClick={restartAll}
                    value={intl.get("runners.restartAll")} />
            </ContentHeader>
            <ContentBody>
                <Table>
                    <thead>
                        <tr>
                            <th width="10"></th>
                            <th width="70">{intl.get("runners.name")}</th>
                            <th width="70">{intl.get("runners.username")}</th>
                            <th width="50">{intl.get("runners.companyName")}</th>
                            <th width="120">{intl.get("runners.subjectName")}</th>
                            <th width="70">{intl.get("runners.calculationType")}</th>
                            <th width="40">{intl.get("runners.calculationProgress")}</th>
                            <th width="40">{intl.get("runners.active")}</th>
                            <th width="40">{intl.get("runners.stale")}</th>
                            <th width="40">{intl.get("runners.restart")}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {runners?.map(runner =>
                            <RunnerItem key={runner.id} runner={runner} />
                        )}
                    </tbody>
                </Table>
            </ContentBody>
        </Layout>
    );
};